module.exports = require("dom-helpers/scrollbarSize");